import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18.44 19.5L4.5 5.56 5.56 4.5 19.5 18.44l-1.06 1.06z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.65 15.46c.54-1.04.85-2.21.85-3.46 0-4.14-3.36-7.5-7.5-7.5-1.25 0-2.43.31-3.46.85l10.11 10.11zM5.36 8.54A7.358 7.358 0 004.5 12c0 4.14 3.36 7.5 7.5 7.5 1.25 0 2.42-.31 3.46-.86L5.36 8.54z"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18.44 19.5L4.5 5.56 5.56 4.5 19.5 18.44l-1.06 1.06z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.65 15.46c.54-1.04.85-2.21.85-3.46 0-4.14-3.36-7.5-7.5-7.5-1.25 0-2.43.31-3.46.85l10.11 10.11zM5.36 8.54A7.358 7.358 0 004.5 12c0 4.14 3.36 7.5 7.5 7.5 1.25 0 2.42-.31 3.46-.86L5.36 8.54z"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M36.88 39L9 11.12 11.121 9l27.88 27.88L36.88 39z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M37.3 30.92C38.38 28.84 39 26.5 39 24c0-8.28-6.72-15-15-15-2.5 0-4.86.62-6.92 1.7L37.3 30.92zM10.72 17.08C9.62 19.16 9 21.5 9 24c0 8.28 6.72 15 15 15 2.5 0 4.84-.62 6.92-1.72l-20.2-20.2z"
  }))
};
export var LightsOff = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});